import appClient from './AppClient';
import { UserBasicDetailsDto } from '../types';
import { endpoints } from '../../../config';

export default class UsersService {
    async getUsersBasicDetails(): Promise<UserBasicDetailsDto[]> {
        const url = `${endpoints.usersUrl}basic-details`;
        const resp = await appClient.get<UserBasicDetailsDto[]>(url);
        return resp.unwrapOr(Array<UserBasicDetailsDto>());
    }
}
